import { required, shape, stopOnFirstFailure, greaterThan } from '@totalsoft/pure-validations';

export const taxRateValidator = shape({
  code: required,
  description: required,
  percent: [required, greaterThan(-0.0001)] |> stopOnFirstFailure
});
